<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <Tab></Tab>
    <div class="promotion-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/h5/Nav.vue'
  import Tab from '@/components/h5/Tab.vue'
  export default {
    name: 'Promotion',
    components: {
      Nav,
      Tab
    },
    mounted: function () {
    }
  }
</script>

<style lang="less" scoped>
  .promotion-wrap{
    position: absolute;
    //top: 88px;
    width: 100%;
  }
  /deep/.el-table--border, /deep/.el-table--group{
    border: 1px solid #EEEEEE;
  }
  /deep/.el-table thead{
    background: #F7F8FA;
    color: #C9CACB;
    font-weight: normal;
  }
  /deep/.el-table td, /deep/.el-table th.is-leaf{
    border-bottom: 1px solid #EEEEEE;
  }
  /deep/.el-table--border td, /deep/.el-table--border th, /deep/.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #EEEEEE;
  }
  /deep/.el-table thead th{
    background: #F7F8FA;
    color: #858586;
    font-weight: normal;
  }
  /deep/.el-table tbody tr{
    color: #222222;
  }
  /deep/.text-center{
    text-align: center;
  }
  /deep/.form-item .el-input__inner{
    border: 1px solid #E8E8E8;
    border-radius: 2px;
    color: #666666;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
  }
  /deep/.van-overlay{
    background-color: rgba(0,0,0,.6);
  }
  /deep/ .time-input .el-input__inner{
    border: none;
    outline: none;
    background: #F7F7F7;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;
  }
  /deep/.el-icon-times{
    background: url(../../../assets/img/h5/btn_calendar.png) center no-repeat;
    background-size: contain;
    line-height: 32px;
    width: 22px;
  }
  /deep/.van-popup--bottom.van-popup--round {
    border-radius: 16px 16px 0 0;
  }
  /deep/.van-picker__toolbar {
    margin: 6px 0;
  }
  /deep/ .van-picker__cancel{
    font-size: 16px;
    color: #999999;
  }
  /deep/ .van-picker__confirm{
    font-size: 16px;
    color: #FC3E3E;
  }
  /deep/ .van-picker__title{
    font-size: 18px;
    color: #666666;
  }
  /deep/.van-hairline--top-bottom::after, /deep/.van-hairline-unset--top-bottom::after {
    border-width: 0;
  }
  /deep/ .van-hairline::after{
    border: none;
  }
  /deep/.van-dialog__header{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 18px;
    color: #222222;
  }
  /deep/.date-picker{
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 2px;
    padding: 2px 10px;
    text-align: center;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #222222;
    input{
      border: none !important;
      padding: 0 !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .date-range{
      margin-right: 5px;
    }
    .el-col{
      position: relative;
      .clear-icon{
        right: 30px;
        position: absolute;
        width: 22px;
        top: 50%;
        transform: translateY(-50%);
        -ms-transform: translateY(-50%);	/* IE 9 */
        -moz-transform: translateY(-50%); 	/* Firefox */
        -webkit-transform: translateY(-50%); /* Safari 和 Chrome */
        -o-transform: translateY(-50%); 	/* Opera */
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/Index.vue